import React, { useEffect, useState } from 'react';
import * as libCon from '../community-hats-js-library/Constants';
import { SimpleCopyField } from '../elements/SimpleStoreCopyField';
import { RefContextLanguage } from '../providers/LanguageProvider';

const LOADING = '----';

function SensorInboxEmail() {
  const i18n = RefContextLanguage();

  const [email, setEmail] = useState(LOADING);

  useEffect(() => {
    const getTheEmail = async () => {
      setEmail(libCon.SENSOR_INBOX_EMAIL);
    };

    getTheEmail();
  }, []);

  return (
    <div>
      <SimpleCopyField
        title={i18n.t('sensorInboxOptions')}
        value={email === LOADING ? LOADING : email.replace('@', '7@')}
      />
      <SimpleCopyField value={email === LOADING ? LOADING : email.replace('@', '8@')} />
      <SimpleCopyField value={email === LOADING ? LOADING : email.replace('@', '9@')} />
      <SimpleCopyField value={email === LOADING ? LOADING : email.replace('@', '10@')} />
      <SimpleCopyField value={email === LOADING ? LOADING : email.replace('@', '11@')} />
      <SimpleCopyField value={email === LOADING ? LOADING : email.replace('@', '12@')} />
      <SimpleCopyField value={email === LOADING ? LOADING : email.replace('@', '13@')} />
    </div>
  );
}

export default SensorInboxEmail;
